import {Injectable} from "@angular/core";
import {ApiService} from "../services/api/api.service";
import {AppScope} from "../services/app_scope.service";
import {GenericDataService} from "./generic-data.service";
import {Configuration} from "../_models/configuration";

@Injectable({
    providedIn: 'root'
})
export class ConfigDataService {

    constructor(private api: ApiService,
                private appScope: AppScope,
                private genericData: GenericDataService
    ) {
    }

    upsertConfig(config: Configuration) {
        if (config.id) {
            return this.api.configuration.obsPatch(config)
        } else {
            return this.api.configuration.obsSave(config)
        }
    }
}
